import { Component, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid/grid.base.case';
import { ProductStorageComponent } from './product-storage/product-storage.component';
import { GiftInventoryFormComponent } from './gift-inventory-form/gift-inventory-form.component';
import { TransferGiftsDetailComponent } from './transfer-gifts-detail/transfer-gifts-detail.component';
import { TransferGiftsFormComponent } from './transfer-gifts-form/transfer-gifts-form.component';
import { TransferGiftsListSrlComponent } from './transfer-gifts-list-srl/transfer-gifts-list-srl.component';
import { GiftAuditListComponent } from './gift-audit-list/gift-audit-list.component';
import { GiftAuditDetailComponent } from './gift-audit-detail/gift-audit-detail.component';
import { GiftReceiptComponent } from './gift-receipt/gift-receipt.component';
import { InventoryAuditListComponent } from './inventory-audit-list/inventory-audit-list.component';
import { InventoryapprovalManagerComponent } from './inventoryapproval-manager/inventoryapproval-manager.component';
import {ProductInventoryApprovalComponent} from './product-inventory-approval/product-inventory-approval.component'
@Component({
  selector: 'app-nestle-crm',
  templateUrl: './nestle-crm.component.html',
  styleUrls: ['./nestle-crm.component.scss']
})
export class NestleCrmComponent extends GridBaseCase {
  @ViewChild("storage") gift_inventory: GiftInventoryFormComponent;
  @ViewChild("giftdetail") gift_detail: TransferGiftsDetailComponent;
  @ViewChild("giftadd") gift_add: TransferGiftsFormComponent;
  @ViewChild("gift_srl") gift_srl: TransferGiftsListSrlComponent;


  @ViewChild("gift_audit") gift_audit: GiftAuditListComponent;
  @ViewChild("gift_audit_detail") gift_audit_detail: GiftAuditDetailComponent;
  @ViewChild("receiptform") receiptform: GiftReceiptComponent;
  @ViewChild("productStorage") productStorage: ProductStorageComponent;
  @ViewChild("inventory_audit") inventory_audit: InventoryAuditListComponent;
  @ViewChild("storageeachapproval") storageeachapproval: InventoryapprovalManagerComponent;
  @ViewChild("productInventoryApproval") productInventoryApproval: ProductInventoryApprovalComponent;
  constructor() {
    super();
  }

  ngOnInit() {
    // debugger;
    console.log(this.template, "日志");
  }

  /**
   * 全局提交按钮
   * @param param 
   * @param type 
   * @param btnType 
   */
  Nestlesubmit(param, type: any = 0, btnType: any = true) {
    let that = this;
    switch (param) {
      case 'GiftInventoryForm':
        //赠品盘库
        this.gift_inventory.EventSubmitClick();
        break;
      case 'TransferGiftsDetail':
        //赠品调货详情
        this.gift_detail.EventSubmitClick();
        break;
      case 'TransferGiftsForm':
        //赠品调货添加
        this.gift_add.EventSubmitClick(btnType);
        break;
      case 'TransferGiftsListSRL':
        //赠品调货SRL列表添加
        this.gift_srl.EventSubmitClick(btnType);
        break;
      // GiftAuditList
      case 'GiftAuditList':
        //赠品审批  批量审批 批量驳回
        this.gift_audit.EventSubmitClick(btnType);
        break;
      case 'GiftAuditDetail':
        //赠品审批  批量审批 批量驳回
        this.gift_audit_detail.EventSubmitClick(btnType);
        break;
        case 'InventoryAuditList':
          //库存审批  批量审批 批量驳回
          this.inventory_audit.EventSubmitClick(btnType);
          break;
          case 'storageeachapproval':
            //盘库审批  批量审批 批量驳回
            this.storageeachapproval.EventSubmitClick(btnType);
            break;
            // 赠品盘库审批
            case 'productInventoryApproval':
              //盘库审批  批量审批 批量驳回
              this.productInventoryApproval.EventSubmitClick(btnType);
              break;
      case 'GiftReceiptForm':
        //赠品审批  批量审批 批量驳回
        this.receiptform.EventSubmitClick();
        break;
      case 'ProductStorage':
        //产品入库提交
        this.productStorage.EventSubmitClick();
        break;


    }
  }

  /**
   * 全选事件
   */
  NestleSelectAll(param, type: any, index: number = 0) {
    let that = this;
    // debugger;
    switch (param) {
      //赠品签收审批列表
      case 'GiftAuditList':
        that.gift_audit.EventCheckAllToggle();
        break;
        //库存审批列表
          case 'InventoryAuditList':
        that.inventory_audit.EventCheckAllToggle();
        break;
         //盘库审批审批列表
         case 'storageeachapproval':
          that.storageeachapproval.EventCheckAllToggle();
          break;
           //赠品盘库审批审批列表
         case 'productInventoryApproval':
          that.productInventoryApproval.EventCheckAllToggle();
          break;
          
    }
  }

}
